import { createContext, useContext, useState } from "react";
import { Fade, Modal, Box } from "@mui/material";

const ModalContext = createContext({});

export function ModalContextProvider({ children }) {
    const [isOpen, setIsOpen] = useState(false);

    const [image, setImage] = useState(false);

    const handleClose = () => {
        setIsOpen(false);
        setImage(false);
    };

    const handleOpen = () => setIsOpen(true);

    const value = {
        setImage,
        handleOpen,
        handleClose,
    };

    const styles = {
        image:
        {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            boxShadow: 24,
            maxHeight: '80vh',
            outline: 'none'
        }

    };

    const GlobalModal = () => {
        return (
            <Modal open={isOpen} onClose={handleClose} closeAfterTransition >
                <Fade in={isOpen}>
                    <Box component={'img'} sx={styles.image} borderRadius={1} src={image} />
                </Fade>
            </Modal>
        );
    };

    return (
        <ModalContext.Provider value={value}>
            <GlobalModal />
            {children}
        </ModalContext.Provider>
    );
}

export function useModal() {
    return useContext(ModalContext);
};
